<script lang="ts" setup>
import type { PropertyFilterDto } from "~~/server/api/ecom/products/search.post";
import type { CatalogPageRecord, CatalogSectionRecord, LayoutRecord } from "~~/server/graphql/datocms/generated";

interface FilterType {
  name: string;
  value: string | PropertyFilterDto;
}

const { data: catalogSection } = defineProps<{ data: CatalogSectionRecord }>();

const layout = await useLayout();
const catalogPage = await useCatalogPage();

const productIdList = (catalogSection.filterProducts as Array<FilterType>)?.map(product => Number(product.value)) ?? [];

const propertyFilterList = (catalogSection.filterProperties as Array<FilterType>)?.map((filter: FilterType) => {
  if (typeof filter.value === "string") {
    return JSON.parse(filter.value) as PropertyFilterDto;
  }

  return filter.value as PropertyFilterDto;
});
</script>

<template>
  <div v-if="layout && catalogPage" class="mb-3xl lg:mb-5xl">
    <ProductSearchBase
      v-if="productIdList?.length || propertyFilterList?.length"
      :layout="layout as LayoutRecord"
      :cms-data="catalogPage as CatalogPageRecord"
      :page-title="catalogSection.title"
      :filter="{ productIdList, propertyFilterList }"
      :show="{ categoryDrilldown: false }"
    />

    <FeedbackMessage v-else :msg="catalogPage.messageNoItems" type="warning" />
  </div>
</template>

<style scoped>

</style>
